import type { TopicsSummaryShellProps } from '@/modules/employer/pages/components/TopicsSummaryShell/TopicsSummaryShell.types'

import { TopicsSummary } from '@/components/@Shared/UserManagmentCharts/TopicsSummary/TopicsSummary'

import { useEmployerStatsServiceEmployerStatsControllerGetTopicStats } from '@/__generated__/queries'

export function TopicsSummaryShell({
  onUpdateChartsData,
}: TopicsSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useEmployerStatsServiceEmployerStatsControllerGetTopicStats()

  return (
    <TopicsSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
